import source from "./shared-runtime-copy-source.json";
import hu from "./shared-runtime-copy/hu.json";
import bg from "./shared-runtime-copy/bg.json";
import sk from "./shared-runtime-copy/sk.json";
import sl from "./shared-runtime-copy/sl.json";
import type { ReferencePeptide } from "@/lib/research/types";

export type SharedRuntimeCopyKey = keyof typeof source;
type SharedRuntimeCopy = Record<SharedRuntimeCopyKey, string>;

const translations: Record<string, SharedRuntimeCopy | undefined> = { hu, bg, sk, sl };

/** Existing locales retain the previous source text until reviewed copy is available. */
export function getSharedRuntimeCopy(locale: string | undefined, key: SharedRuntimeCopyKey): string {
	return (locale ? translations[locale]?.[key] : undefined) ?? source[key];
}

/** Only translate known prose; preserve scientific sequences and changed reference facts. */
export function getSharedReferenceSequence(
	peptide: Pick<ReferencePeptide, "slug" | "sequence">,
	locale?: string,
): string | undefined {
	const key = `reference.${peptide.slug}.sequenceDescription`;
	if (!Object.hasOwn(source, key)) return peptide.sequence;
	const copyKey = key as SharedRuntimeCopyKey;
	return peptide.sequence === source[copyKey] ? getSharedRuntimeCopy(locale, copyKey) : peptide.sequence;
}
